import { render } from "./404.vue?vue&type=template&id=0d6b42f6"
const script = {}
script.render = render

export default script